var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":50}}),_c('div',{staticClass:"py-2"},[_vm._v("なう、ろーでぃんぐ。")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }